import React, { ReactElement, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import * as Model from "@models/index";
import * as Middleware from "@middlewares/index";
import { useSelector } from "react-redux";
import { NetworkingFillStatus } from "@interface/enums";

Middleware.Profile.load();

const NetworkingPage = (): ReactElement => {
  const history = useHistory();
  const workshopTitle = useSelector(
    (state: any) => state.Main.Workshop.data.title
  );

  const setNetworkingStatus = (status: boolean) => {
    new Model.Profile().setNetworkingStatus(status).then(() => {
      Middleware.Profile.load().then((response: any) => {
        if (
          status &&
          response.networkingFillStatus === NetworkingFillStatus.Complete
        ) {
          history.push({
            pathname: "/cabinet/networking/profile",
          });
        } else if (
          status &&
          response.networkingFillStatus < NetworkingFillStatus.Complete
        ) {
          history.push({
            pathname: "/cabinet/networking/reg",
          });
        } else {
          history.push({
            pathname: "/service/networking/disabled",
          });
        }
      });
    });
  };

  return (
    <>
      <div className="auth auth--netw">
        <div className="auth__wrapper">
          <div className="auth__header">Ваш статус в «{workshopTitle}»</div>
          <div className="auth__body">
            <p>
              На выставке действует система делового общения «Знай наше».
              Networking. Участники нетворкинга обмениваются контактами и
              назначают видеовстречи потенциальным партнерам. В этом сервисе
              нужно зарегистрироваться дополнительно.
            </p>
            <p>
              Если вы хотите назначать встречи, либо готовы посещать встречи,
              назначенные вам партнерами, обмениваться визитками, вам необходимо
              подтвердить участие в нетворкинге, выбрав кнопку{" "}
              <span>«Вебинары + нетворкинг»</span>
            </p>
          </div>
          <hr />
          <div className="auth__footer">
            <p className="auth__footer-desc">
              Выберите формат вашего участия в онлайн-выставке:
            </p>
            <div className="auth__footer-buttons">
              <button
                className="btn btn--grey"
                onClick={() => {
                  setNetworkingStatus(false);
                }}
              >
                Только вебинары
              </button>
              <button
                className="btn btn--blue-white"
                onClick={() => {
                  setNetworkingStatus(true);
                }}
              >
                Вебинары + нетворкинг
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NetworkingPage;
